<script setup>
defineProps({
  items: {
    type: Array,
    default: () => [],
  },
});

const formatCurrency = (value) => {
  return new Intl.NumberFormat("th-TH", {
    style: "currency",
    currency: "THB",
    minimumFractionDigits: 0,
  }).format(value || 0);
};
</script>
<template>
  <div class="card border-0 shadow-sm rounded-4 h-100">
    <div class="card-body p-4">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h5 class="fw-bold mb-1">รายงานอายุหนี้ค้างชำระ</h5>
          <div class="text-muted small">
            แสดงจำนวนเคสและยอดค้างชำระตามช่วงอายุหนี้
          </div>
        </div>
        <i class="bi bi-clock-history text-danger fs-4"></i>
      </div>

      <div class="table-responsive">
        <table class="table align-middle mb-0">
          <thead class="table-light">
            <tr>
              <th>ช่วงอายุหนี้</th>
              <th class="text-end">จำนวนเคส</th>
              <th class="text-end">ยอดค้าง</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in items" :key="item.label">
              <td>
                <span
                  class="badge rounded-pill"
                  :class="`text-bg-${item.color}`"
                  >{{ item.label }}</span
                >
              </td>
              <td class="text-end fw-semibold">
                {{ item.cases.toLocaleString("th-TH") }}
              </td>
              <td class="text-end fw-semibold text-danger">
                {{ formatCurrency(item.amount) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
